export const RECEIVE_USER_PROFILE_STATS = 'RECEIVE_USER_PROFILE_STATS';
